import { TextCell } from '../../models';
import { CardListCell } from 'src/app/components/pages-partials/card-list/card-list-cell';
import { Injectable } from '@angular/core';
import { CellParserBase } from './cell-parser-base';
import { CardListCellTypes } from 'src/app/components/pages-partials/card-list/card-list-cell-types.enum';

@Injectable({ providedIn: 'root' })
export class StatusIconCellParser extends CellParserBase {
  parse(cell: TextCell): CardListCell {
      let textResolver = this.getTextResolver(cell);
      let footerResolver = this.getFooterResolver(cell);
      let csvResolver = this.getCsvResolver(cell);

    return {
      type: CardListCellTypes.statusIcon,
      class: cell.class,
      textResolver: textResolver,
      csvResolver,
      footerResolver: cell.footer ? footerResolver: null,
      title: cell.title,
      text: cell.overrideText,
      sortProperty: cell.sortProperty,
      sortDataType: cell.sortDataType
    };
  }
}
